<template>
    <div v-if="!updatingData" class="card">
        <div class="card-body">
            <div class="dropdown float-end">
            </div>
            <div class="d-flex align-items-center">
                <div><img v-bind:src="require('@/assets/avatar-small.png')" alt=""
                        class="avatar-md rounded-circle img-thumbnail" /></div>
                <div class="flex-1 ms-3">
                    <h5 class="font-size-16 mb-1"><a href="#" class="text-dark">Philippe T.</a></h5>
                    <span v-if="type=='email'" class="badge badge-soft-success mb-0">E-mail</span>
                    <span v-if="type=='mobile'" class="badge badge-soft-danger mb-0">Numéro mobile</span>
                </div>
            </div>
            <div class="mt-3 pt-1">
                <p v-if="type=='mobile'" class="text-muted mb-0">
                    <font-awesome-icon class="font-size-15 align-middle pe-2 text-primary" :icon="['fas', 'comment-sms']" size="xl" />
                     070
                    2860 5375
                </p>
                <p v-if="type=='email'" class="text-muted mb-0">
                    <font-awesome-icon class="font-size-15 align-middle pe-2 text-primary" :icon="['fas', 'envelope']" size="xl" />
                    xxxxx@gmail.com</p>
            </div>
            <div class="d-flex gap-2 pt-4">
                <ButtonDisplay class="w-50" text="Supprimer" type="delete" @click="updatingData = !updatingData"/>
                <ButtonDisplay class="w-50" text="Modifier" type="edit" @click="updatingData = !updatingData"/>
            </div>
        </div>
    </div>
    <div v-else class="card">
        <div class="card-body">
            <div class="dropdown float-end">
            </div>
            <div class="d-flex align-items-center">
                <div><img v-bind:src="require('@/assets/avatar-small.png')" alt=""
                        class="avatar-md rounded-circle img-thumbnail" /></div>
                <div class="flex-1 ms-3">
                    <input type="text" v-model="newName" class="form-control" placeholder="Nom" />
                    <span v-if="type=='email'" class="badge badge-soft-success mb-0">E-mail</span>
                    <span v-if="type=='mobile'" class="badge badge-soft-danger mb-0">Numéro mobile</span>
                </div>
            </div>
            <div class="mt-3 pt-1">
                <p v-if="type=='mobile'" class="text-muted mb-0 d-flex">
                    <font-awesome-icon class="font-size-15 align-middle pe-2 text-primary" :icon="['fas', 'comment-sms']" size="xl" />
                    <input type="text" v-model="newPhone" class="form-control" placeholder="Num. mobile" />
                </p>
                <p v-if="type=='email'" class="text-muted mb-0 d-flex">
                    <font-awesome-icon class="font-size-15 align-middle pe-2 text-primary" :icon="['fas', 'envelope']" size="xl" />
                    <input type="text" v-model="newMail" class="form-control" placeholder="E-mail" />
                </p>
            </div>
            <div class="d-flex gap-2 pt-4">
                <ButtonDisplay class="w-50" text="Annuler" type="cancel" @click="updatingData = !updatingData"/>
                <ButtonDisplay class="w-50" text="Enregistrer" type="save" @click="updatingData = !updatingData"/>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'


export default {
    props: ["type"],
    components: {
        ButtonDisplay,
    },
    data() {
        return {
            updatingData: false,
            newName: null,
            newPhone: null,
            newMail: null
        };
    },
}
</script>

<style>
.card {
    margin-bottom: 24px;
    box-shadow: 0 2px 3px #e4e8f0;
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #eff0f2;
    border-radius: 1rem;
}

.avatar-md {
    height: 4rem;
    width: 4rem;
}

.rounded-circle {
    border-radius: 50% !important;
}

.img-thumbnail {
    padding: 0.25rem;
    background-color: #f1f3f7;
    border: 1px solid #eff0f2;
    border-radius: 0.75rem;
}

.avatar-title {
    align-items: center;
    background-color: #3b76e1;
    color: #fff;
    display: flex;
    font-weight: 500;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.bg-soft-primary {
    background-color: rgba(59, 118, 225, .25) !important;
}

a {
    text-decoration: none !important;
}

.badge-soft-danger {
    color: #f56e6e !important;
    background-color: rgba(245, 110, 110, .1);
}

.badge-soft-success {
    color: #63ad6f !important;
    background-color: rgba(99, 173, 111, .1);
}

.mb-0 {
    margin-bottom: 0 !important;
}

.badge {
    display: inline-block;
    padding: 0.25em 0.6em;
    font-size: 75%;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.75rem;
}
</style>